package co.maytes.standupbot.dashboard.styles

import co.maytes.standupbot.dashboard.components.widgets.cssRgb
import co.maytes.standupbot.shared.design.StatusHue
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import org.jetbrains.compose.web.css.StyleScope

object HealthStripClasses {
    const val ROOT = "hs-root"
    const val HEAD = "hs-head"
    const val HEAD_TEXT = "hs-head-text"
    const val ROWS = "hs-rows"
    const val ROW = "hs-row"
    const val ROW_BAD = "hs-row--bad"
    const val ROW_WARN = "hs-row--warn"
    const val ROW_MUTED = "hs-row--muted"
    const val NAME = "hs-name"
    const val FACTS = "hs-facts"
    const val ACTION = "hs-action"
    const val STALE = "hs-stale"
}

private fun InitSilkContext.rule(
    selector: String,
    build: StyleScope.() -> Unit,
) {
    stylesheet.registerStyle(selector) { base { Modifier.styleModifier(build) } }
}

@InitSilk
fun initHealthStripStyles(ctx: InitSilkContext) {
    ctx.rule(".${HealthStripClasses.ROOT}") {
        property("display", "flex")
        property("flex-direction", "column")
        property("gap", Spacing.sm.toString())
        property("padding", "${Spacing.sm} ${Spacing.lg}")
        property("min-width", "0")
    }
    ctx.rule(".${HealthStripClasses.HEAD}") {
        property("display", "flex")
        property("align-items", "center")
        property("flex-wrap", "wrap")
        property("gap", Spacing.sm.toString())
        property("min-width", "0")
    }
    ctx.rule(".${HealthStripClasses.HEAD_TEXT}") {
        property("flex", "1 1 16rem")
        property("min-width", "0")
        property("font-size", Typography.bodySmall.size.toString())
        property("color", Palette.textPrimary.cssRgb())
    }
    ctx.rule(".${HealthStripClasses.ROWS}") {
        property("display", "flex")
        property("flex-direction", "column")
        property("min-width", "0")
        property("border-top", "1px solid ${Palette.borderSubtle.cssRgb()}")
    }
    ctx.rule(".${HealthStripClasses.ROW}") {
        property("display", "flex")
        property("align-items", "center")
        property("flex-wrap", "wrap")
        property("gap", "${Spacing.xs} ${Spacing.md}")
        property("padding", "${Spacing.xs} 0")
        property("min-width", "0")
        property("border-bottom", "1px solid ${Palette.borderSubtle.cssRgb()}")
    }
    ctx.rule(".${HealthStripClasses.ROW_BAD}") {
        property("box-shadow", "inset 0.1875rem 0 0 ${Palette.status(StatusHue.Danger).solid.cssRgb()}")
        property("padding-left", Spacing.sm.toString())
    }
    ctx.rule(".${HealthStripClasses.ROW_WARN}") {
        property("box-shadow", "inset 0.1875rem 0 0 ${Palette.status(StatusHue.Warning).solid.cssRgb()}")
        property("padding-left", Spacing.sm.toString())
    }
    ctx.rule(".${HealthStripClasses.ROW_MUTED}") {
        property("opacity", "0.72")
    }
    ctx.rule(".${HealthStripClasses.NAME}") {
        property("display", "flex")
        property("align-items", "center")
        property("gap", Spacing.xs.toString())
        property("flex", "0 0 11rem")
        property("min-width", "0")
    }
    ctx.rule(".${HealthStripClasses.FACTS}") {
        property("display", "flex")
        property("flex-direction", "column")
        property("flex", "1 1 14rem")
        property("min-width", "0")
        property("font-size", Typography.bodySmall.size.toString())
        property("color", Palette.textSecondary.cssRgb())
    }
    ctx.rule(".${HealthStripClasses.ACTION}") {
        property("margin-left", "auto")
    }
    ctx.rule(".${HealthStripClasses.STALE}") {
        property("font-size", Typography.caption.size.toString())
        property("color", Palette.textTertiary.cssRgb())
    }
}
